import { useEffect, useState } from 'react'
import { axiosClient as axios } from '../axios'

export function useFormComponents(formId = '') {
    const [components, setComponents] = useState()
    const [error, setError] = useState()

    useEffect(() => {
        axios
            .get(`/wp-json/contact-form-7/v1/contact-forms/${formId}`)
            .then(response => setComponents(response.data))
            .catch(error => setError(error))
    }, [formId])

    return [components, error]
}

export function formValidate(formId, formData) {
    return new Promise((resolve, reject) => {
        let formData_ = new FormData()

        for (let key in formData) {
            formData_.append(key, formData[key])
        }

        axios
            .post(
                `/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`,
                formData_
            )
            .then(response => {
                if (response.data.status === 'validation_failed')
                    reject(response.data)
                else resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}
